import instance from "../utils/request.js"
import { getRequest } from "../utils/request.js"

/*获取费用成本信息*/
export function GetCost(data = {}){
return instance.request({
        method: "get",
        url: "basicdata/cost/",
        params:data
    })
}

/*获取费用成本编辑信息*/
export function CostEditInfo(data = {}){
return instance.request({
        method: "get",
        url: "basicdata/costedit/",
        params:data
    })
}

/*费用成本编辑*/
export function CostEdit(data = {}){
    let params = new URLSearchParams();
    params.append('costid',data.costid);
    params.append('size',data.size);
    params.append('carat',data.carat);
    params.append('price',data.price);
    params.append('suppliername',data.suppliername);
    params.append('notes',data.notes);
    params.append('carat_price',data.carat_price)
return instance.request({
        method: "post",
        url: "basicdata/costedit/",
        data:params
    })
}

/*费用成本新增*/
export function CostAdd(data = {}){
    let params = new URLSearchParams();
     params.append('size',data.size);
    params.append('carat',data.carat);
    params.append('price',data.price);
    params.append('name',data.name);
    params.append('color',data.color);
    params.append('carat_price',data.carat_price);
    params.append('unit',data.unit);
    params.append('category',data.category);
    params.append('quality',data.quality);
    params.append('suppliername',data.suppliername);
    params.append('notes',data.notes);
return instance.request({
        method: "post",
        url: "basicdata/costadd/",
        data:params
    })
}

/*费用成本删除*/
export function CostDel(data = {}){
    let params = new URLSearchParams();
    params.append('costid',data.costid)
return instance.request({
        method: "post",
        url: "basicdata/costdel/",
        data:params
    })
}